// extracted by mini-css-extract-plugin
module.exports = {"searchSelect":"Search_searchSelect-3YpY3","search":"Search_search-26aJ6"};